<template>
  <!-- 购物打卡-订单明细 -->
  <div>
    <jd-form
      ref="jdForm"
      :form-info="inputData"
      :formData.sync="formList"
      @search="search" />

    <div style="margin: 16px 0 12px" class="flex-between">
      <jd-button
        style="visibility: hidden"
        @click="addCrowd"
        :disabled="tableData.length <= 0"
        >按查询结果生成人群</jd-button
      >
      <jd-button type="text" @click="exportAll"v-permission="'hide:checkOrder:export'" >导出</jd-button>
    </div>
    <orderDetailOverview ref="orderDetailOverviewRef" :rowData="rowData"></orderDetailOverview>
    <div class="new-table-box" style="margin-top: 16px">
      <jd-table
        :tableData="tableData"
        :loading="loading"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: total,
          }"
        @handlePage="handlePage"
      >
        <el-table-column prop="orderId" label="订单号" min-width="120">
        </el-table-column>
        <el-table-column prop="rootId" label="父订单号" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.rootId || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          :prop="chaosParams"
          :label="`用户${grayText}`"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="memberNick"
          label="用户昵称"
          min-width="150"
        ></el-table-column>
        <el-table-column prop="orderStartTime" label="下单时间" width="180">
        </el-table-column>
        <el-table-column prop="paymentConfirmTime" label="付款时间" width="180">
        </el-table-column>
        <el-table-column prop="orderPayment" label="订单金额" width="130" align="right">
        </el-table-column>
      <el-table-column prop="skuNameList" label="商品名称" min-width="200">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded, 'ellipsis-double': goodsNameColumnExpanded }"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
            </el-table-column>
        <el-table-column prop="orderStateRemark" label="订单状态" width="120">
        </el-table-column>
      </jd-table>
    </div>

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="formList"
      :activityType="53"
      :source="41"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import {
  getShoppingCheckIn,
  exportShoppingCheckIn,
  orderDetailExports
} from "@/api/jhk/shoppingCheckIn.js";
import { orderDetailPage } from "@/api/jhk/paradiseAndTaskCommonController.js";

import crowdDialog from "../crowd-Dialog.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import { customSellerLinkPage } from "@/api/jhk/activityController";
import orderDetailOverview from "./orderDetailOverview.vue";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
    orderDetailOverview,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      goodsNameColumnExpanded: false,
      inputData: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "父订单号：",
          prop: "rootId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
           { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
        },
        {
          label: "下单时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
      ],
      tableData: [],
      formList: {
        current: 1,
        size: 10,
        startTime: "",
        endTime: "",
        memberNick: "",
        orderState: "",
        orderId: "",
        rootId: "",
        activityId: this.activityId,
      },
      total: 0,
      loading: false,
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      sellerLinkList:[]
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  mounted() {
    this.searchMethods();
  },
  watch: {
    searchGrayId: {
      handler(newVal, oldVal) {
        this.inputData.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    // 切换商品名称列展开/收起状态
    toggleGoodsNameExpand(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      // 切换状态变量，控制内容行展开/收起
      this.goodsNameColumnExpanded = !this.goodsNameColumnExpanded;
      // 直接修改当前点击的按钮文字，精准高效，不会丢失事件
      e.target.innerText = this.goodsNameColumnExpanded ? '【收起】' : '【展开】';
    },
    exportAll() {
      this.openRemarkDialog = true;
    },
    confirmExport(exportRemark = "") {
      let obj = this.$refs.jdForm.export_fun2();
      let params = {
        ...obj,
        activityId: this.activityId,
        current: 1,
        size: 9999999,
        exportRemark: exportRemark,
      };
      orderDetailExports(params).then((res) => {});
    },
    handleCurrent(val) {
      this.formList.current = val;
      this.searchMethods();
    },
    handlePage(val) {
       this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.searchMethods();
    },
    handleSize(val) {
      this.formList.size = val;
      this.formList.current = 1;
      this.searchMethods();
    },
    search(params, type) {
      this.formList.current = 1;
      for (const key in params) {
        this.formList[key] = params[key];
      }
      this.formList.activityId = this.activityId
      if (type == "reset") {
        this.formList = {
          size: 10,
          current: 1,
          activityId: this.activityId,
        };
      }
      this.searchMethods();
    },
    searchMethods() {
      this.loading = true;
      this.$refs.orderDetailOverviewRef.getDataOverview(this.formList);
      orderDetailPage(this.formList)
        .then((res) => {
          if (res.code == 1) {
            let arr = res.data.records
            this.tableData = arr;
            this.total = Number(res.data.total);
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.goods-name-text.ellipsis-single {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
